import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.659 1.529a.667.667 0 1 0-.943.942l5.529 5.53h-4.39A1.333 1.333 0 0 0 1.52 9.332v1.334A1.333 1.333 0 0 0 2.854 12h8.39l2.472 2.471a.667.667 0 1 0 .943-.942zM6 10.667h3.911L8.578 9.333H6zM4.667 9.333v1.334H2.854V9.333z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.52 3.333a.667.667 0 1 0-1.332 0v.334a2 2 0 0 0 2 2 .667.667 0 0 1 .666.666v.334a.667.667 0 1 0 1.334 0v-.334a2 2 0 0 0-2-2 .667.667 0 0 1-.667-.666zM10.854 8.667c0-.368.299-.667.667-.667h2a1.333 1.333 0 0 1 1.333 1.333v1.334c0 .373-.154.711-.4.952a.667.667 0 0 1-.933-.952V9.333h-2a.667.667 0 0 1-.667-.666"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })